import { View } from 'react-native';
import { Icon } from '../../../../../icon/Icon';
import { ICON_NAMES } from '../../../../../icon/icon.helper';
import TextLato from '../../../../../text/text-lato/TextLato';
import { styleDesktop, styleMobile } from '../StepCard.style';
import Button from '../../../../../buttons/button/Button';
import { Image } from 'expo-image';
import { FocusGroups } from '../../../../../focus-provider/FocusProvider.constants';
import { observer } from 'mobx-react-lite';
import { TestIDs } from 'src/constants/testIDs.constants';
import { useStore } from 'src/contexts/StoreContext';
import { modalTestID } from 'src/helpers/testIDs.helper';
import { brand, neutrals } from 'src/theme/colors';
import { CardProps } from '../../ModalConfigurationSteps.types';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';
import { FormatInfo } from '@photosi/expo-photosi-sdk/build/PrintUtils';

export const FormatCard = observer(
  ({ item: format, index, isSelected, onPress, onFocus, productGroup }: CardProps<FormatInfo>) => {
    const { i18n } = useStore();
    const isSuggested = format.isSuggested;
    const formattedCode = format.code.split('.')[0];
    const { isDesktop } = useResponsiveScreen();
    const style = isDesktop ? styleDesktop : styleMobile;

    return (
      <Button
        onFocus={onFocus}
        onPress={async () => onPress(format)}
        testID={modalTestID(TestIDs.CONFIGURATION_STEPS, index.toString())}
        focusId={modalTestID(TestIDs.CONFIGURATION_STEPS, index.toString())}
        focusGroup={FocusGroups.MODAL}
        focusOrder={index}
        key={`format-card_${format.code}`}
      >
        {({ focused }) => {
          return (
            <View style={[style.border, isSelected ? style.borderSelected : focused ? style.borderFocus : undefined]}>
              <View style={style.card}>
                {isSuggested && (
                  <View style={style.badge}>
                    <View style={[style.icon, { padding: 2 }]}>
                      <Icon name={ICON_NAMES.Star} color={neutrals.white} filled />
                    </View>
                    <TextLato style={style.textBadge}>{i18n.t('modal-configuration-steps:suggested')}</TextLato>
                  </View>
                )}
                <Image style={style.image} source={{ uri: format.previewImageUrl }} />
                <View style={style.textContainer}>
                  <TextLato style={style.textTitle}>
                    {i18n.t(`modal-configuration-steps:format:${formattedCode}`)}
                  </TextLato>
                  <View style={style.description}>
                    {isSuggested && (
                      <View style={style.icon}>
                        <Icon
                          name={ICON_NAMES.NoCut}
                          color={isSelected ? brand.main.water : neutrals.neutralGrays.cement}
                        />
                      </View>
                    )}

                    <TextLato style={[style.textDescription, isSelected && { color: brand.main.water }]}>
                      {isSuggested
                        ? i18n.t(`modal-configuration-steps:formats-content:suggested`)
                        : i18n.t(`modal-configuration-steps:formats-content:${productGroup}:${formattedCode}`)}
                    </TextLato>
                  </View>
                </View>
                {isDesktop && (
                  <View style={[style.radioButton, isSelected && { borderColor: brand.main.water }]}>
                    {isSelected && <View style={style.radioButtonSelected} />}
                  </View>
                )}
              </View>
            </View>
          );
        }}
      </Button>
    );
  },
);
